

































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import UUIFComponent from '@/shared/uuifComponent';
import { v4 as uuidv4 } from 'uuid';
const cssPrefix = 'recaptchComponent';
@Component({
  components: {
    SwTextfield,
    ...UUIFComponent,
  },
})
export default class RecaptchaComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;
  captchaUrl: string = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit';
  siteKey: string = '6LdTFSAUAAAAAMGRZ28liaRZCd59-yGRwquTl4tD';
  isLoadCustomCaptcha: boolean = false;

  // customCaptcha
  customCaptchaInput:string = '';
  captchaImg: string = '';
  customCaptchaCode: string = '';
  customCaptchaValid: boolean = false;
  customCaptchaErrors: any = {};

  captchaResponse: string = '';

  // googlerecaptcha
  isGoogleCaptchaValid: boolean = false;

  mounted() {
    (window as { [key: string]: any })['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    };
    (function (d, s, id, obj) {
      let js: any;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptch();
        return;
      }
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = obj.captchaUrl;
      js.onerror = () => {
        obj.onCaptchaLoadError();
      };
      fjs &&
      fjs.parentNode &&
      fjs!.parentNode!.insertBefore(js, fjs);
    }(document, 'script', `recaptcha${uuidv4()}`, this));
  }
  renderReCaptch() {
    if ((window as { [key: string]: any })['grecaptcha'] === undefined ||
      (window as { [key: string]: any })['grecaptcha'] === null) {
      this.onCaptchaLoadError();
      return;
    }
    const recaptchaID = document.getElementById('recaptcha');
    if (recaptchaID) {
      (window as { [key: string]: any })['grecaptcha'].render(recaptchaID, {
        sitekey : this.siteKey,
        callback: (response: any) => {
          this.captchaResponse = response;
          this.isGoogleCaptchaValid = true;
        },
        'expired-callback': () => {
          this.$emit('expiredResponse');
          (window as { [key: string]: any })['grecaptcha'].reset();
          this.isGoogleCaptchaValid = false;
        },
        'error-callback': () => {
          // this.onCaptchaLoadError();
          console.error('captcha error');
        },
      });
    }
  }
  onCaptchaLoadError() {
    this.loadCustomCaptcha();
  }
  loadCustomCaptcha() {
    this.$store.dispatch('getCaptcha')
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
          this.isLoadCustomCaptcha = true;
          this.captchaImg = res.content.captchBaseString;
          this.customCaptchaCode = res.content.captchDetail.split('%5e')[1];
          this.customCaptchaValid = false;
          this.customCaptchaErrors.empty = this.customCaptchaErrors.invalid = this.customCaptchaErrors.timedout = false;
          this.customCaptchaInput = '';
        }
      });
  }
  fetchCaptcha(): { status: string; response: string; msg: string; } {
    if (this.isLoadCustomCaptcha) {
      if (this.customCaptchaInput === '') {
        return {
          status: 'error',
          response: '',
          msg: `${this.$t('recaptcha.recaptchaCustomError')
            .toString()}`,
        };
      }
      this.captchaResponse = `CH^${this.customCaptchaInput}^${this.customCaptchaCode}`;
      return {  status:'success', response: this.captchaResponse, msg: '' };
    }
    if (this.captchaResponse && this.isGoogleCaptchaValid) {
      return { status:'success', response: this.captchaResponse, msg: '' };
    }
    return {
      status: 'error',
      response: '',
      msg: `${this.$t('recaptcha.recaptchaGoogleError')
        .toString()}`,
    };
  }
}
